import Loader from "react-loader-spinner";
import { faBroom, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Envelope, EyeFill, EyeSlashFill, List, Search, TelephoneOutbound } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getAllProvinces, getCityList } from "../store/api/LocationAPI";
import { getStaffExtSettings } from "../store/api/SystemSettingsAPI";
import { clickToCall, isMobileApp, setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import BihamtaTable from "../../Components/BihamtaTable";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { deleteStaff, getStaffMobilesByFilter, searchStaff } from "../store/api/StaffAPI";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSendSMS from "../../Components/Modals/ModalSendSMS";

const SearchStaff = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const [showFilter, setShowFilter] = useState(true);
    const { register, handleSubmit } = useForm();
    const [parentStaff, setParentStaff] = useState(null);
    const [popAgency, setPopAgency] = useState({ show: false });
    const [selectedUser, setSelectedUser] = useState(null);
    const [popUser, setPopUser] = useState({ show: false });
    const [modalSMS, setModalSMS] = useState({ show: false });
    const filterData = useRef({});
    const filterState = useSelector(state => state.StaffReducer.staffSearchFilters);
    if (filterState) {
        filterData.current = { ...filterState };
    }
    const { staffExtSettings, cityList, provinceList } =
        useSelector(state => {
            return {
                staffExtSettings: state.SystemSettingsReducer.staffExtSettings,
                cityList: state.locationDataReducer.cityList,
                provinceList: state.locationDataReducer.provinceList,
            }
        });
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "Code", colTitle: "کد", showInMobile: true },
        { colName: "FirstName", colTitle: "نام", showInMobile: true },
        { colName: "LastName", colTitle: "نام خانوادگی", showInMobile: true },
        {
            colName: "Mobile", colTitle: "موبایل", showInMobile: false,
            button: {
                icon: <TelephoneOutbound size={14} className="rowBtn" color="#007a80" />,
                onClick: (item) => call(item.Mobile),
                showCondition: item => item.Mobile?.length > 9
            }
        },
        {
            colName: "Phone", colTitle: "تلفن", showInMobile: false,
            button: {
                icon: <TelephoneOutbound size={14} className="rowBtn" color="#007a80" />,
                onClick: (item) => call(item.Phone),
                showCondition: item => item.Phone?.length > 3
            }
        },
        { colName: "IsAgency", colTitle: "نماینده", showInMobile: false, colType: "boolean" }
    ];
    const tableRowButtons = [
        { title: "نمایش", type: "common", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobileApp() },
        {
            title: "حذف ", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف تکنسین/نماینده',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteStaff(item.ID, () => search(filterData.current))
                }))
            }
        }
    ];
    function rowClick(row) {
        history.push(`/Services/AddEditStaff/${row.IsAgency}/${row.ID}`);
    }
    function showModalAgency() {
        filterState.ParentID = null;
        setPopAgency({
            show: true,
            forAgency: true,
            onSelect: setParentStaff
        })
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        data.Skip = 0;
        filterData.current = { ...data };
        dispatch(searchStaff(data));
    }
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID));
    }
    function clearFilters() {
        frmFilters.current.reset();
        setParentStaff(null);
        dispatch(searchStaff({ Take: 10, Skip: 0 }));
    }
    function showModalUser() {
        const onSelect = (data) => {
            if (filterState) {
                filterState.RelatedUserID = "";
                filterState.RelatedUserName = ""
            }
            setSelectedUser(data);
        }
        setPopUser({
            show: true,
            selectUserWithName: onSelect
        })
    }
    function showModalSMS() {
        const onGetMobile = (data) => {
            if (!data || !data.Data || !Array.isArray(data.Data)) {
                setErrorDialog(dispatch, data.Message ?? data.Error ?? "Error", "دریافت شماره های همراه");
                return;
            }
            const mobiles = data.Data.join(",");
            setModalSMS({
                show: true,
                to: mobiles,
                filterData: filterData.current
            })
        }
        getStaffMobilesByFilter(filterData.current, onGetMobile);
    }
    function call(callNumber) {
        callNumber = callNumber.replace(" ", "");
        if (!callNumber || callNumber === "") {
            return;
        }
        const onCall = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تماس با تکنسین/نماینده");
            }

        }
        clickToCall(callNumber, onCall)
    }
    useEffect(() => {
        dispatch(getStaffExtSettings());
        dispatch(getAllProvinces());
        if (filterState?.CityID && filterState?.ProvinceID) {
            loadCityList(filterState?.ProvinceID);
        }
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <span>
                        <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;
                        جستجوی نماینده/تکنسین
                    </span>
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalSelectStaff setPopSelectStaff={setPopAgency} popData={popAgency} />
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} templateType="staffs" sendFromModel="staff" />
                    <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row className="rowBorder" id="divFilters">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>کد:</label>
                                <Form.Control name="Code" ref={register({})} defaultValue={filterState?.Code ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کد دوم:</label>
                                <Form.Control name="Code2" ref={register({})} defaultValue={filterState?.Code2 ?? ""} />
                            </Col>                            
                            <Col md={2} className="form-group">
                                <label>نام:</label>
                                <Form.Control name="FirstName" ref={register({})} defaultValue={filterState?.FirstName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام خانوادگی:</label>
                                <Form.Control name="Name" ref={register({})} defaultValue={filterState?.Name ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره همراه: </label>
                                <Form.Control name="Mobile" ref={register({})} defaultValue={filterState?.Mobile ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نماینده اصلی: </label>
                                <input type="hidden" name="ParentID" value={parentStaff?.ID ?? filterState?.ParentID ?? ""} readOnly ref={register({})} />
                                <Form.Control name="ParentStaffName" value={parentStaff?.LastName ?? filterState?.ParentStaffName ?? ""} readOnly ref={register({})} />
                                <Button className="btn-input-tiny" style={{ top: "26px" }} onClick={showModalAgency}><List size={20} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کاربر مرتبط: </label>
                                <input type="hidden" name="RelatedUserID" ref={register({})} readOnly value={selectedUser?.ID ?? filterState?.RelatedUserID ?? ""} />
                                <Form.Control name="RelatedUserName" readOnly value={selectedUser?.Name ?? filterState?.RelatedUserName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: "26px" }} onClick={showModalUser}><List size={20} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>استان: </label>
                                {provinceList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                    </div>
                                }
                                {provinceList && Array.isArray(provinceList) &&
                                    <select className="form-control" name="ProvinceID" ref={register({})} onChange={e => loadCityList(e.target.value)} defaultValue={filterState?.ProvinceID}>
                                        <option value="">انتخاب کنید</option>
                                        {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شهر: </label>
                                {cityList === "PENDING" &&
                                    <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                {cityList && Array.isArray(cityList) &&
                                    <select className="form-control" name="CityID" ref={register({})} defaultValue={filterState?.CityID}>
                                        <option value="">انتخاب کنید</option>
                                        {cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col>
                            {staffExtSettings && Array.isArray(staffExtSettings) &&
                                staffExtSettings.map((ext, i) =>
                                    <Col md={2} className="form-group" key={i}>
                                        <label>{ext.SettingValue}</label>
                                        <Form.Control name={`ExtraAttr${i + 1}`} ref={register({})} defaultValue={filterState ? filterState[`ExtraAttr${i + 1}`] ?? "" : ""} />
                                    </Col>)
                            }
                            <Col md={2} className="form-group" style={{ display: "flex", alignItems: "center", color: "blue" }}>
                                <div className="rowBorder form-group mt-4" style={{ padding: "8px 5px 8px 5px", width: "100%" }}>
                                    <input type="checkbox" name="IsAgency" id="IsAgency" className="form-check-input" ref={register({})} defaultChecked={filterState?.IsAgency} />
                                    &nbsp;
                                    <label htmlFor="IsAgency">نماینده</label>
                                    &nbsp;
                                    &nbsp;
                                    <input type="checkbox" name="IsActive" id="IsActive" className="form-check-input" ref={register({})} defaultChecked={filterState?.IsActive} />
                                    &nbsp;
                                    <label htmlFor="IsActive">فعال</label>
                                    &nbsp;
                                    &nbsp;
                                    <input type="checkbox" name="IsBlackList" id="IsBlackList" className="form-check-input" ref={register({})} defaultChecked={filterState?.IsBlackList} />
                                    &nbsp;
                                    <label htmlFor="IsBlackList">لیست سیاه</label>
                                    &nbsp;
                                </div>
                            </Col>
                            {/* <Col md={2}>
                            <label>مرتب سازی براساس:</label>
                            <select className="form-control">
                                <option value="NAME">نام-صعودی</option>
                                <option value="NAME DESC">نام-نزولی</option>
                            </select>
                            </Col> */}
                        </Row>
                        <div className="mt-1">
                            <Button type="submit" variant="secondary" className="group-Btn-large"><Search size={18} />&nbsp;جستجوی نماینده/تکنسین</Button>
                            <Button className="group-Btn-large" onClick={showModalSMS}><Envelope size={15} />&nbsp;ارسال پیامک به لیست</Button>
                        </div>
                    </form>
                    <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} filterData={filterData.current} rowClick={rowClick}
                        searchMethod={(data) => dispatch(searchStaff(data))} reducerName="StaffReducer" objectName="searchStaffList" hasPaging={true} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default SearchStaff;